import styled from 'styled-components';
import Dropdown from 'react-bootstrap/Dropdown';
import DropdownToggle from 'react-bootstrap/DropdownToggle';
import DropdownMenu from 'react-bootstrap/DropdownMenu';

export const UserDropdownContainer = styled(Dropdown)`
  background-color: transparent;
  border: none;
`;

export const ImageContainer = styled(DropdownToggle)`
  margin: 0;
  padding: 0;
  display: flex;
  align-items: center;
  gap: 10px;

  border: none;

  .user-name {
    max-width: 180px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-family: ${(props) => props.theme.font.body.family};
    font-size: ${(props) => props.theme.font.body.size.small};
    font-weight: ${(props) => props.theme.font.body.weight.bold};
    color: ${(props) => props.theme.color.text.inverse};

    @media only screen and (max-width: 1100px) {
      display: none;
    }
  }

  &::after {
    display: none;
  }

  img {
    border-radius: 50%;
    width: 34px;
    height: 34px;
  }
`;

export const Menu = styled(DropdownMenu)`
  border-radius: 0;
  margin-top: 24px;
  width: 260px;

  border: none;
  padding: 16px 24px;

  cursor: default;

  .tooltipArrow {
    position: absolute;
    top: -12px;
    right: 54px;
    width: 0;
    height: 0;
    border-style: solid;
    border-width: 0 15px 15px 15px;
    border-color: transparent transparent white transparent;
  }

  box-shadow: 0 8px 12px rgba(52, 87, 140, 0.12); /* Shadow/4 do Figma */
`;

export const MenuHeader = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 8px;

  h4 {
    text-overflow: ellipsis;
    font-weight: ${(props) => props.theme.font.title.weight.bold};
    margin: 0;
  }

  span {
    overflow: hidden;
    text-overflow: ellipsis;
  }

  padding-bottom: 16px;
  border-bottom: 1px solid ${(props) => props.theme.color.ui.shade2};
`;

export const MenuBody = styled.div`
  display: flex;
  flex-direction: column;

  margin-top: 10px;
  gap: 10px;

  a {
    text-decoration: none;
  }

  span {
    cursor: pointer;
    font-size: ${(props) => props.theme.font.body.size.regular};
    color: ${(props) => props.theme.color.text.danger};
  }
`;
